const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://xcentralback.onrender.com";

export { API_BASE_URL };
